import {
  PagePoliciesList,
  PagePolicyReview,
  PagePolicyVerify,
  PagePolicyChange,
  PagePolicyDone,
  PagePolicyMileage,
} from '../../../../pages/mypages'
import ErrorPage from '../../../../pages/shared/ErrorPage'
import { FSMCommonTransitions } from '../../constants'

const {
  POLICIES,
  POLICIES_LIST,
  POLICIES_PAYMENT_ERROR,
  POLICY_REVIEW,
  POLICY_VERIFY,
  POLICY_CHANGE,
  POLICY_DONE,
  POLICY_MILEAGE,
} = FSMCommonTransitions

export default [
  {
    is: { [POLICIES]: POLICIES_LIST },
    page: PagePoliciesList,
  },
  {
    is: { [POLICIES]: POLICY_REVIEW },
    page: PagePolicyReview,
  },
  {
    is: { [POLICIES]: POLICY_VERIFY },
    page: PagePolicyVerify,
  },
  {
    is: { [POLICIES]: POLICY_CHANGE },
    page: PagePolicyChange,
  },
  {
    is: { [POLICIES]: POLICY_DONE },
    page: PagePolicyDone,
  },
  {
    is: { [POLICIES]: POLICY_MILEAGE },
    page: PagePolicyMileage,
  },
  {
    is: { [POLICIES]: POLICIES_PAYMENT_ERROR },
    page: ErrorPage,
  },
]
